
import moment from 'moment-timezone';

import {
	read as momentFromIso,
	write as momentToIso,
} from 'ko-extender-view-moment-from-iso';

export const DATE_FORMAT = 'DD.MM.YYYY HH:mm';
const DATE_FORMAT_WITH_SECONDS = 'DD.MM.YYYY HH:mm:ss';
export const TIME_ZONE = 'Europe/Moscow';

export const read = iso => {
	const m = momentFromIso(iso);
	if (!m.isValid()) {
		return iso;
	}
	return m.tz(TIME_ZONE).format(DATE_FORMAT);
};

export const write = lrd => {
	const m = moment.tz(lrd, DATE_FORMAT, true, TIME_ZONE);
	if (m.isValid()) {
		return momentToIso(m);
	}
	return lrd;
};

export const moscowRussianDateTimeViewExtend = { view: { moscowRussianDateTime: { read, write } } };

export const readWithSeconds = iso => {
	const m = momentFromIso(iso);
	if (!m.isValid()) {
		return iso;
	}
	return m.tz(TIME_ZONE).format(DATE_FORMAT_WITH_SECONDS);
};

export const writeWithSeconds = lrd => {
	const m = moment.tz(lrd, DATE_FORMAT_WITH_SECONDS, true, TIME_ZONE);
	if (m.isValid()) {
		return momentToIso(m);
	}
	return lrd;
};

export const moscowRussianDateTimeWithSecondsViewExtend = {
	view: {
		moscowRussianDateTimeWithSeconds: {
			read: readWithSeconds,
			write: writeWithSeconds,
		},
	},
};
